<div class="parent-card animated fadeIn fast">
  <mat-card>
    <mat-card-header style="padding: 2px">
      <div
        mat-card-avatar
        class="header-image"
        style="background-image: url('{{
          parent?.icons.d128_url
        }}'); padding: 0px; margin-right: 12px; margin-left: 8px; margin-top: 8px;"
      ></div>
      <div class="col-8 font-text" style="word-wrap: break-word; display: inline-block">
        <mat-card-title style="font-size: 16px">{{ parent?.nombre }}</mat-card-title>
        <mat-card-subtitle style="font-size: 13px">Categoría {{ parent?.id }}</mat-card-subtitle>
      </div>
    </mat-card-header>

    <mat-divider></mat-divider>
    <br />

    <mat-card-content>
      <div class="central-content">
        <div class="information">
          <p class="subtitle">ID</p>
          <p class="title">{{ parent?.id }}</p>
        </div>

        <div class="information" *ngIf="parent?.parentId !== null">
          <p class="subtitle">Parent ID</p>
          <p class="title">
            <a
              class="parent"
              matTooltip="Volver a la categoria padre"
              (click)="redirectToParent()"
              >{{ parent?.parentId }}</a
            >
          </p>
        </div>

        <div class="information">
          <p class="subtitle">Nombre</p>
          <p class="title">{{ parent?.nombre ? parent.nombre : 'Nombre no ingresado' }}</p>
        </div>

        <div class="information">
          <p class="subtitle">Fuente</p>
          <p class="title">{{ parent?.fuente ? parent.fuente : 'Fuente no ingresada' }}</p>
        </div>

        <div class="information">
          <p class="subtitle">Red</p>
          <p class="title">{{ parent?.red ? 'Habilitado' : 'Deshabilitado' }}</p>
        </div>

        <div class="information">
          <p class="subtitle">Icono</p>
          <p class="title">
            <img
              [src]="parent?.icons.d128_url"
              (error)="iconErrorHandler($event)"
              class="icon"
              alt="parent category icon"
            />
          </p>
        </div>

        <div class="information">
          <p class="subtitle">Marcador</p>
          <p class="title">
            <img
              [src]="parent?.markers.d128_url"
              (error)="markerErrorHandler($event)"
              class="icon"
              alt="parent category marker"
            />
          </p>
        </div>

        <div class="information">
          <p class="subtitle">N° de Pois</p>
          <p class="title">{{ parent?.poisCount }}</p>
        </div>

        <div class="information">
          <p class="subtitle">Descripción</p>
          <p class="title">
            {{ parent?.descripcion ? parent.descripcion : 'Descripción no ingresada' }}
          </p>
        </div>

        <div *ngIf="poisList.length > 0">
          <google-map
            height="250px"
            width="250px"
            [center]="center"
            [zoom]="zoom"
            [options]="mapOptions"
          >
            <map-marker
              *ngFor="let poi of poisList; let i = index"
              [position]="{ lat: poi.lat!, lng: poi.lng! }"
              [options]="markerOptions"
              (mapClick)="openInfoWindow(markerElem, i)"
              #markerElem="mapMarker"
            >
              <map-info-window>
                <a aria-label="View" [routerLink]="['poi', poi.id]">
                  {{ poi.nombre }}
                </a>
                <br />
                <em>{{ poi.direccionCompleta }}</em>
              </map-info-window>
            </map-marker>
          </google-map>
        </div>
      </div>
    </mat-card-content>

    <mat-divider></mat-divider>

    <mat-card-actions>
      <div class="actions">
        <a mat-stroked-button aria-label="View" matTooltip="Descargar CSV" (click)="csvOnClick()">
          <mat-icon class="icon-csv">insert_drive_file</mat-icon>
        </a>
        <a
          mat-stroked-button
          aria-label="View"
          matTooltip="Editar"
          [routerLink]="['/', 'category', parent?.id, 'edit']"
          (click)="setCategoryToEdit()"
        >
          <mat-icon class="icon-edit">edit</mat-icon>
        </a>
        <a
          mat-stroked-button
          aria-label="View"
          matTooltip="Eliminar"
          (click)="openDialogToDelete()"
        >
          <mat-icon class="icon-delete">delete</mat-icon>
        </a>
        <a
          mat-stroked-button
          aria-label="View"
          matTooltip="Volver al inicio"
          [routerLink]="['/', 'categories']"
        >
          <mat-icon class="icon-back">arrow_circle_left</mat-icon>
        </a>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
